module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/kulturniMapa@2x-501a8b1ba15327563bab3b20427aae6a.png";